import { Injectable } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { UserDataService } from '../data/user-data.service';
import { StorageService } from '../utils/storage.service';
import { UserModel } from '../../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  constructor(
    private userDataService: UserDataService,
    private storageService: StorageService
  ) {}

  async restoreUserFromSession(): Promise<UserModel | null> {
    try {
      const session = await Auth.currentSession();
      const payload = session.getIdToken().payload;

      const user: UserModel = {
        firstName: payload['cognito:username'],
        //email: payload.email, // optional: add more fields as needed
      };

      console.log('User', JSON.stringify(user));

      await this.storageService.set<UserModel>('USER', user);
      this.userDataService.setUser(user);

      return user;
    } catch (error) {
      //console.warn('[AuthStateService] No valid Cognito session found:', error);
      return null;
    }
  }
}
